import { Rototilt } from "../../../interfaces/api/Rototilt";
import { UpperBracket } from "../../../interfaces/api/UpperBracket";
import { filterHelper } from "../../../shared/helpers/filterHelper";
import { filtering } from "../../../shared/helpers/productFilterHelper";
import { useMarket } from "../../../store/hooks/useMarket";
import { ProductData } from "../../../store/interfaces/productData";

interface FilterUpperBracketsProps {
  upperBracketsData: ProductData;
  selectedTiltrotator: Rototilt;
}

interface FilterUpperBracketsOutput {
  filteredUpperBrackets: UpperBracket[];
}

export const useFilterUpperBrackets = ({
  upperBracketsData,
  selectedTiltrotator,
}: FilterUpperBracketsProps): FilterUpperBracketsOutput => {
  const market = useMarket();

  if (!upperBracketsData) {
    return {
      filteredUpperBrackets: [],
    };
  }

  const unfilteredUpperBrackets = upperBracketsData.data as UpperBracket[];

  const filteredUpperBrackets = unfilteredUpperBrackets
    .filter((upperBracket) => filtering.market(upperBracket, market))
    .filter((upperBracket) =>
      filterHelper.upperBrackets({
        tiltrotator: selectedTiltrotator,
        upperBracket,
      })
    );

  return {
    filteredUpperBrackets: filteredUpperBrackets || unfilteredUpperBrackets,
  };
};
